import { inject, Injectable } from '@angular/core';
import { from } from 'rxjs';

import { WindowRef } from '@amfam/shared/utility/shared-services/lib/window/window.service';

import { UserAnalyticParams } from '../models/analytics.model';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private win = inject(WindowRef);

  profileInfo = {} as UserAnalyticParams;

  loadGoogleTagManagerScript() {
    return from(
      new Promise<void>(resolve => {
        resolve();
        // Set up the GTM script
        // let script, scriptRef;
        // const dataLayerName = 'dataLayer';
        // const gtmId = 'GTM-K52ZTSS'; // GTM container ID
        // this.win.nativeWindow[dataLayerName] = this.win.nativeWindow[dataLayerName] || [];

        // // Create the GTM script tag
        // script = document.createElement('script');
        // scriptRef = document.getElementsByTagName('script')[0];
        // script.async = true;
        // script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

        // script.onload = () => {
        //   resolve();
        // };
        // script.onerror = (error: any) => {
        //   reject(error);
        // };

        // // Finally, append the GTM script tag in the DOM
        // scriptRef.parentNode.insertBefore(script, scriptRef);
      }).then(
        () => {
          // GTM script loaded successfully
        },
        reason => {
          throw new Error(reason);
        }
      )
    );
  }

  sendAnalytic(options: unknown) {
    this.pushToGTMDataLayer(options);
  }

  private pushToGTMDataLayer(obj: unknown) {
    if (obj) this.win.nativeWindow.dataLayer.push(obj);
  }
}
